import { last, range } from 'ramda';
import { isNotNil } from 'ramda-adjunct';
export const getUnloadedWindow = (start, end, visible) => {
    const indicesToTest = range(start, end);
    const unloadedIndices = indicesToTest.filter((index) => !visible.has(index));
    const windowStart = unloadedIndices[0];
    const windowEnd = last(unloadedIndices);
    if (windowStart === undefined || windowEnd === undefined) {
        return;
    }
    /* single unloaded index: windowStart === windowEnd → return [start, end) so we load that index */
    return [windowStart, windowEnd + 1];
};
const getPreviousWindow = (currentWindowStart, pageSize, visible) => {
    const previousHalfWindowStart = Math.max(0, currentWindowStart - pageSize);
    if (!getUnloadedWindow(previousHalfWindowStart, currentWindowStart, visible)) {
        return;
    }
    const previousWindowStart = Math.max(0, currentWindowStart - 2 * pageSize);
    return getUnloadedWindow(previousWindowStart, currentWindowStart, visible);
};
const getNextWindow = (currentWindowEnd, pageSize, visible) => {
    const nextHalfWindowEnd = currentWindowEnd + pageSize;
    if (!getUnloadedWindow(currentWindowEnd, nextHalfWindowEnd, visible)) {
        return;
    }
    const nextWindowEnd = currentWindowEnd + 2 * pageSize;
    return getUnloadedWindow(currentWindowEnd, nextWindowEnd, visible);
};
export const getRangeToLoad = (visibleStart, visibleEnd, pageSize, loaded) => {
    const previousWindow = getPreviousWindow(visibleStart, pageSize, loaded);
    const currentWindow = getUnloadedWindow(visibleStart, visibleEnd, loaded);
    const nextWindow = getNextWindow(visibleEnd, pageSize, loaded);
    if (!previousWindow && !currentWindow && !nextWindow) {
        return undefined;
    }
    const starts = [previousWindow?.[0], currentWindow?.[0], nextWindow?.[0]].filter(isNotNil);
    const ends = [previousWindow?.[1], currentWindow?.[1], nextWindow?.[1]].filter(isNotNil);
    const loadedRangeStart = Math.min(...starts);
    const loadedRangeEnd = Math.max(...ends);
    return {
        offset: loadedRangeStart,
        pageSize: loadedRangeEnd - loadedRangeStart,
    };
};
//# sourceMappingURL=getRangeToLoad.js.map